<template lang="pug">
  section.center
    transition( name="description" )
      .container
        .powergage( :style="getHeight" )
          .power( :style="getPower" )
          .gage
            p.start 0
            .line.start
            p.ready READY
            .line.ready
            p.max MAX
            .line.max
        .calender
          .date
            .dateCount {{ dateCount.month }}/{{ dateCount.day }}
            i( class="fas fa-arrow-right" )
            .dateLimit {{ dateLimit.month }}/{{ dateLimit.day }}
          .message {{ message }}
          circle-btn(
            text="TOUCH!",
            :isAlive="chargeBtn.isAlive",
            @onClick="onCharge"
          )
</template>

<script>
import CircleBtn from "../CircleBtn";

export default {
  components: {
    CircleBtn
  },

  props: {
    date: Date,
    member: Number,
    distance: Number
  },

  data() {
    return {
      status: true,
      dateCount: {
        date: new Date(),
        year: 0,
        month: 0,
        day: 0
      },
      dateLimit: {
        year: 0,
        month: 0,
        day: 0
      },
      dateMax: 0,
      dateCountTime: 0,
      chargeBtn: {
        isAlive: false,
        isClicked: false
      },
      power: 0,
      powerMax: 0,
      powergageHeight: 0,
      message: ""
    };
  },

  computed: {
    getHeight() {
      return {
        height: this.powergageHeight + "px"
      };
    },

    getPower() {
      let background;

      if (this.power >= this.powerMax * 0.8) {
        background = "rgba(32, 128, 256, 0.5)";
      } else {
        background = "rgba(256, 64, 0, 0.5)";
      }

      let height = this.powergageHeight * (this.power / this.powerMax);

      /*console.log("-----------------------------------");
      console.log(height + "/" + this.powergageHeight);
      console.log(this.power + "/" + this.powerMax);*/

      return {
        background: background,
        height: height + "px"
      };
    }
  },

  mounted() {
    switch (this.distance) {
      case 0:
        this.powerMax = 30;
        break;
      case 1:
        this.powerMax = 45;
        break;
      case 2:
        this.powerMax = 60;
        break;
      case 3:
        this.powerMax = 75;
        break;
      case 4:
        this.powerMax = 90;
        break;
    }

    //set limit date
    this.dateLimit.year = this.date.getFullYear();
    this.dateLimit.month = this.date.getMonth() + 1;
    this.dateLimit.day = this.date.getDate();

    this.dateMax = (this.dateLimit.month - 1) * 30 + this.dateLimit.day;
    this.dateCountTime = Math.ceil(10000 / this.dateMax);

    //set today
    this.dateCount.year = this.dateCount.date.getFullYear();
    this.dateCount.month = this.dateCount.date.getMonth() + 1;
    this.dateCount.day = this.dateCount.date.getDate();

    this.checkHeight();

    window.resize = () => {
      this.checkHeight();
    };

    this.message = "READY";

    setTimeout(() => {
      this.chargeBtn.isAlive = true;
      this.dateProgress();
    }, 2000);
  },

  methods: {
    checkHeight() {
      this.powergageHeight = window.innerHeight * 0.8;
    },

    onCharge() {
      this.power++;
      this.powerCheck();

      this.chargeBtn.isClicked = true;

      setTimeout(() => {
        this.chargeBtn.isClicked = false;
      }, 50);
    },

    dateProgress() {
      this.power -= 0.1;
      this.powerCheck();

      this.dateUpdate();

      if (this.status) {
        if (this.date.getTime() <= this.dateCount.date.getTime()) {
          this.dateUpdate();
          this.onChargeFix();
        } else {
          setTimeout(() => {
            this.dateProgress();
          }, this.dateCountTime);
        }
      }
    },

    dateUpdate() {
      //update date
      this.dateCount.date.setDate(this.dateCount.date.getDate() + 1);
      this.dateCount.year = this.dateCount.date.getFullYear();
      this.dateCount.month = this.dateCount.date.getMonth() + 1;
      this.dateCount.day = this.dateCount.date.getDate();

      this.$emit("onChargeDateUpdate", this.dateCount.date);
    },

    powerCheck() {
      if (this.power < 0) {
        this.power = 0;
        this.message = "CHARGE POWER!";
      } else if (this.power >= this.powerMax) {
        this.message = "KEEP EFFORT!";
        this.power = this.powerMax;
      } else if (this.power >= this.powerMax * 0.8) {
        this.message = "KEEP EFFORT!";
      }

      this.$emit("onCharge", this.power / this.powerMax);
    },

    onChargeFix() {
      if (this.power >= this.powerMax * 0.8) {
        this.$emit("onChargeFix", {
          result: true,
          power: this.power / this.powerMax
        });
      } else {
        this.$emit("onChargeFix", {
          result: false,
          power: this.power / this.powerMax
        });
      }
    }
  },

  beforeDestory() {
    this.status = false;
  }
};
</script>

<style scoped lang="scss">
.container {
  width: 100% !important;
  max-width: 100% !important;
  height: 100% !important;

  .powergage {
    position: relative;
    width: 100%;

    .power {
      width: 100%;
      height: 0px;
      position: absolute;
      bottom: 0%;
      transform-origin: center bottom;
      background-blend-mode: screen;
      transition: all 50ms ease;
    }

    .gage {
      width: 100%;
      height: 100%;
      color: #fff;
      text-align: left;

      .line {
        position: absolute;
        width: 100%;
        height: 1px;
        background-color: #fff;

        &.start {
          bottom: 0%;
        }

        &.ready {
          top: 20%;
        }

        &.max {
          top: 0%;
        }
      }

      p {
        position: absolute;
        width: 100%;
        font-family: "ELECNA", sans-serif;
        font-size: 2.8rem;
        letter-spacing: 0.25rem;
        padding: 2rem;

        &.start {
          bottom: 0%;
        }

        &.ready {
          top: 20%;
        }

        &.max {
          top: 0%;
        }
      }
    }
  }

  .calender {
    position: absolute;
    width: 100%;
    max-width: 100%;
    height: 80%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;

    .date {
      margin-bottom: 2rem;
      display: flex;
      justify-content: center;
      align-items: center;

      .dateCount,
      .dateLimit {
        font-family: "ELECNA", sans-serif;
        font-size: 4rem;
        width: 100%;
        margin: 0 1rem;
        display: flex;
        justify-content: center;
        align-items: fle;
        color: #fff;
      }

      i {
        font-size: 2rem;
        color: #fff;
      }
    }

    .message {
      margin-bottom: 2rem;
      padding: 0.5rem;
      font-family: "ELECNA", sans-serif;
      font-size: 3rem;
      color: #fff;
      background-color: #000;
      animation: message 0.01s infinite alternate;
    }

    @-webkit-keyframes message {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
    @-moz-keyframes message {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
    @keyframes message {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }

    .charge-container {
      width: 120px;
      height: 120px;
      margin-bottom: 2rem;
      transition: all 0.25s ease;
      transform: scale(0, 0);

      &.alive {
        transform: scale(1, 1);
      }

      .charge {
        width: 100%;
        height: 100%;
        background-color: #fff;
        border-radius: 50%;
        font-family: "ELECNA", sans-serif;
        font-size: 1.4rem;
        cursor: pointer;
        cursor: hand;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: all 0.1s ease;

        &.clicked {
          transform: scale(0.75, 0.75);
        }
      }
    }
  }
}
</style>
